var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfileMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.991 16.1248C20.991 18.8327 19.1004 20.7571 16.7682 20.7571C14.436 20.7571 12.5454 18.8327 12.5454 16.1248C12.5454 13.4169 14.436 11.7988 16.7682 11.7988C19.1004 11.7988 20.991 13.4169 20.991 16.1248Z",
    stroke: "#6048A1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7734 31.6858C27.7734 34.4711 24.5159 36.7291 17.0234 36.7291C9.53101 36.7291 6.27344 34.4711 6.27344 31.6858C6.27344 28.9005 11.0864 26.6425 17.0234 26.6425C22.9605 26.6425 27.7734 28.9005 27.7734 31.6858Z",
    stroke: "#6048A1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4609 7.16669L31.9837 10.4457L35.5729 10.8807L32.9249 13.3423L33.6203 16.8902L30.4609 15.1324L27.3016 16.8902L27.997 13.3423L25.349 10.8807L28.9381 10.4457L30.4609 7.16669Z",
    stroke: "#6048A1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileMagic);
export default __webpack_public_path__ + "static/media/user-profile-magic.20b30a1359b40b47b3e32d48c9467b25.svg";
export { ForwardRef as ReactComponent };